<template>
  <div class="group-pill">
    <BasePill v-bind="{ ...$props, ...$attrs }">
      <template #icon>
        <UserIcon16 />
      </template>
    </BasePill>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import UserIcon16 from '@components/Icons/UserIcon16.vue';
import BasePill from '@components/common/BasePill.vue';

export default defineComponent({
  name: 'UserPill',

  components: {
    UserIcon16,
    BasePill,
  },
});
</script>
